import React from "react";

import { Alert } from "@material-ui/lab";

export const MultiSaleReportsPermissionNotice = (): React.JSX.Element => (
  <Alert severity="info">
    Generating reports needs the Multi Sale Reports feature. Contact AgriNous
    support to enable it.
  </Alert>
);
